<template lang="pug">
    .data-source(:class="{ 'is-active': status }")
        .data-header
            .data-title {{ name }}
            label.data-checkbox.control
                input.input(type="radio" name="data-source" :value="name" :checked="status === true" @change="update('status', $event.target.checked)")
                .checkmark
        .data-settings
            .title.is-5 URL
            EditInput(:value="url" @input="update('url', $event)" is-link)
        .data-footer.control
            button.button.is-text.is-fullwidth(@click="ping" :class="{ 'is-loading': isLoading }") PING
</template>

<script>
import EditInput from "@/components/EditInput";
export default {
  name: "DataSource",
  components: {
    EditInput
  },
  props: {
    name: {
      type: String
    },
    url: {
      type: String
    },
    status: {
      type: Boolean
    },
    settings: {
      type: Object
    }
  },
  data: () => ({ isLoading: false }),
  watch: {
    props() {
      this.update();
    }
  },
  methods: {
    update(prop, value) {
      setTimeout(() => {
        this.$emit("update", Object.assign({}, this.$props, { [prop]: value }));
      });
    },
    ping() {
      this.isLoading = true;
      const img = new Image();
      img.onload = () => {
        this.$notify({
          type: "success",
          title: "🎉 Success",
          text: "Source available!"
        });
        this.isLoading = false;
      };
      img.onerror = () => {
        this.$notify({
          type: "error",
          title: "🚫 Error",
          text: "Source not available"
        });
        this.isLoading = false;
      };

      img.src = new URL(this.url).origin + "/favicon.ico?" + +new Date();
    }
  }
};
</script>

<style lang="scss" scoped>
.data-source {
  padding: 0.5rem;
  border-radius: 5px;
  background: linear-gradient(180deg, #383d41 0%, #d7d2cc 100%);
  transition: all 0.3s ease-in-out;

  &.is-active {
    background: linear-gradient(180deg, #1d976c 29.06%, #93f9b9 100%);

    .data-header {
      .data-checkbox {
        border: 2px solid #008c67;

        .checkmark {
          &::after {
            content: "✓";
          }
        }
      }
    }
  }

  .data-header {
    position: relative;

    .data-title {
      padding-left: 1rem;
      font-size: 1.3rem;
      font-weight: bold;
    }

    .data-checkbox {
      position: absolute;
      right: 0.5rem;
      top: 0.3rem;
      border-radius: 50%;
      border: 2px solid #acacac;
      overflow: hidden;

      .input {
        display: none;
      }

      .checkmark {
        position: relative;
        display: block;
        width: 3rem;
        height: 3rem;
        background-color: $defaultColor;
        border-radius: 3px;
        color: #008c67;
        cursor: pointer;

        &::after {
          content: "";
          position: absolute;
          top: -1rem;
          left: 0.5rem;
          font-size: 3rem;
        }
      }
    }
  }

  .data-settings {
    margin: 0.5rem 0;
    padding: 1rem 0.5rem;
    background: $defaultColor;

    .title {
      padding-left: 1rem;
      margin-bottom: 1rem;
      color: #000;
    }
  }

  .data-footer {
    .title {
      display: block;
      padding: 0.5rem 0;
      color: #000;
      text-decoration: underline;
      font-weight: bold;
      background-color: transparent;
      transition: all 0.2s linear;

      &:hover {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
